module.exports = __webpack_public_path__ + "static/media/CROWNBACARRA.0e717171.jpg";